import { type FC, useMemo } from "react";
import { type Address, getAddress, isAddress } from "viem";
import { useAccount } from "wagmi";

import { useForkStatus } from "../context";
import ActionsCard from "./ActionsCard";
import ConnectWalletNote from "./ConnectWalletNote";
import FaucetAddressCard from "./FaucetAddressCard";
import FaucetAssetsCard from "./FaucetAssetsCard";
import { FaucetProvider } from "./FaucetProvider";
import MyAssetsCard from "./MyAssetsCard";
import { MyAssetsProvider } from "./MyAssetsProvider";

export const FaucetRoute: FC = () => {
  return (
    <div className="flex flex-col gap-y-4">
      <FaucetRouteInternal />
    </div>
  );
};

const FaucetRouteInternal: FC = () => {
  const { options } = useForkStatus();
  const { scripts } = options;
  const { address: account } = useAccount();

  // TODO: temporary workaround to displat balances of DSToken, which cannot be claimed from the faucet
  // and are minted directly from js, see workaroundClaimDSTokens
  const extraAssets = useMemo(() => {
    const extraAssets: Address[] = [];
    if (!scripts) return extraAssets;
    for (const script of scripts) {
      const env = script.env ?? {};
      const dsTokens = env.DS_TOKEN?.split(",") ?? [];
      for (const token of dsTokens) {
        if (isAddress(token)) {
          extraAssets.push(getAddress(token));
        }
      }
    }
    return extraAssets;
  }, [scripts]);

  return (
    <FaucetProvider extraAssets={extraAssets}>
      <MyAssetsProvider>
        <div className="flex flex-col flex-1 rounded-xl bg-background p-4 gap-4">
          <h2>Faucet</h2>

          <div className="grid gap-4 md:grid-cols-2 items-start">
            <div className="flex flex-col gap-4">
              {account ? <MyAssetsCard /> : <ConnectWalletNote />}
              <FaucetAssetsCard />
            </div>

            <div className="flex flex-col gap-4">
              <ActionsCard />
              <FaucetAddressCard />
            </div>
          </div>
        </div>
      </MyAssetsProvider>
    </FaucetProvider>
  );
};
